export class SalaryClassModel {
    id = null;
    name = null;
    field_translations = null;
    salary_class_key = null;
  }
  